export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registration-bonus.vue?vue&type=template&id=30371970"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/registration-bonus.vue?vue&type=template&id=30371970
// module id = ld0q
// module chunks = 0